export default __webpack_public_path__ + "static/media/ARDANA_QCP.1a756b1a.png";